import React, { Component } from 'react'
import Card from 'components/Card'
import ActivityObject from './ActivityObject'
import ActivityAction from './ActivityAction'
import styles from './Activity.css'

const SimpleActivity = ({
  you,
  value,
  users,
  groups,
  reactions,
  notificationMode
}) => {
  return (
    <Card className={styles.activity}>
      <ActivityAction
        you={you}
        {...value}
        groups={groups}
        notificationMode={notificationMode}
      />
      <ActivityObject
        you={you}
        verb={value.verb}
        object={value.object}
        actor={value.actor}
        users={users}
        reactions={reactions}
      />
    </Card>
  )
}

export default SimpleActivity
